import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Component } from 'react';
import { FormControl, Grid, InputLabel, MenuItem, Select, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/styles';
import i18n from '../i18n-ok';
import { editUser } from '../helpers/helper';

class UserProfileFormDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            selectedLanguage: '',
            buttonCreateObjectDisabled: true
        }

        // Languages
        this.languageOptions = [
            { value: 'ca', label: props.t('i18n_ca') },
            { value: 'cz', label: props.t('i18n_cz') },
            { value: 'en', label: props.t('i18n_en') },
            { value: 'fr', label: props.t('i18n_fr') },
            { value: 'it', label: props.t('i18n_it') },
            { value: 'sk', label: props.t('i18n_sk') },
            { value: 'es', label: props.t('i18n_es') }
        ];

        // Bind
        this.handleError = this.handleError.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleOpen = this.handleOpen.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.props.handleDialog(this.handleOpen);
        const language = localStorage.getItem("selectedLanguage");
        this.setState({ selectedLanguage: language });
    }

    handleError = err => {
        console.error(err)
    }

    handleClose = () => {
        this.setState({ open: false });
    };

    handleOpen = (/*entity*/) => {
        this.setState({ open: true });
    }

    handleChange = (event) => {
        localStorage.setItem("selectedLanguage", event.target.value);
        this.setState({ selectedLanguage: event.target.value }, async () => {
            i18n.changeLanguage(this.state.selectedLanguage);

            let userData = { ...JSON.parse(localStorage.getItem("user")) };
            userData["language"] = this.state.selectedLanguage;
            let response = await editUser({
                "uuid": userData.uuid,
                "language": this.state.selectedLanguage
            });

            if (response.status === 401) {
                return;
            }

            let user = localStorage.getItem('user');

            if (user) {
                user = JSON.parse(user);
                user.language = this.state.selectedLanguage; 
                const updatedUser = JSON.stringify(user);
                localStorage.setItem('user', updatedUser);
            } else {
                console.log('Cant find user object in local storage');
            }
        });
    }

    render() {
        const { t } = this.props;

        // Inizializzazione dei contenuti del menu select
        const items = this.languageOptions.map((lang) => <MenuItem key={lang.value} value={lang.value}>{lang.label}</MenuItem>);

        return (
            <Dialog
                fullScreen={this.props.isDesktop}
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{t("profile_dialog")}</DialogTitle>
                <DialogContent>
                    <div style={{ padding: "10px 0px" }}>
                        <FormControl
                            fullWidth
                            sx={{
                                minWidth: {
                                    xs: '100%',
                                    sm: '100%',
                                    md: '480px',
                                    lg: '480px',
                                    xl: '480px'
                                }
                            }}>
                            <InputLabel id="profile-language-select-label">{t("language")}</InputLabel>
                            <Select
                                fullWidth
                                labelId="profile-language-select-label"
                                id="profile-language-select"
                                label={t("language")}
                                value={this.state.selectedLanguage}
                                onChange={this.handleChange}>
                                {items}
                            </Select>
                        </FormControl>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} columns={2}>
                        <Grid item xs={1} style={{ textAlign: "left" }}>
                            <span>&nbsp;</span>
                        </Grid>
                        <Grid item xs={1} style={{ textAlign: "right" }}>
                            <Button onClick={this.handleClose}>
                                {t("close")}
                            </Button>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        );
    }
}

function UserProfileForm(props) {
    // Get flag desktop
    const isDesktop = useMediaQuery(useTheme().breakpoints.down('md'));
    // Inject media query + i18n
    return (
        <UserProfileFormDialog
            {...props}
            isDesktop={isDesktop}
        />
    );
}

export default withTranslation()(UserProfileForm);
